
import React, { Component } from 'react';
import { generate } from 'shortid';
import FieldGroup from './FieldGroup';

class ValidationField extends Component {
  constructor(props) {
    super(props);
    this.id = generate();
  }

  render() {
    const {
      id = this.id,
      state,
      text,
    } = this.props;

    const style = {
      padding: "0px",
      margin: "0px",
    };

    return (
      <FieldGroup
          id={id}
          formStyle={style}
          hideControl={true}
          validationState={state}
          help={text} />
    );
  }
}

export default ValidationField;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/ValidationField.js